<template>
    <div class="m-address-select-inner">
        <div class="i-cascader-component">
            <el-cascader :placeholder="placeholder"
                         :options="addressOptions"
                         :popper-class="noSelectProvince?'no-select-province': ''"
                         :props="propsConfig"
                         :disabled="disabled"
                         :collapse-tags="collapseTags"
                         ref="cascader"
                         v-model="addressArr"
                         @input="change"
                         @change="changeHandle"
                         @visible-change="visibleChange"
                         :clearable="clearable"></el-cascader>
        </div>
    </div>
</template>

<script>
import _ from '@/components/lots/utils';
import { getAreaApi } from '@/components/lots/api.js'
const millisecond = 1000;
const sixty = 60;
const timeOfDay = 24;
export default {
    props: {
        value: {
            type: [Array, String],
            defalut () {
                return [];
            }
        },
        noSelectProvince: {
            type: Boolean,
            default() {
                return false
            },
        },
        collapseTags: {
            type: Boolean,
            default () {
                return true;
            }
        },
        basicProps: {
            type: Object,
            default () {
                return {};
            }
        },
        minLayers: {
            type: Number,
            default () {
                return 0;
            }
        },
        placeholder: String,
        disabled: {
            type: Boolean,
            default () {
                return false;
            }
        },
        clearable: {
            type: Boolean,
            default () {
                return true;
            }
        },
        // 地址选择器缓存时效（毫秒）
        difference: {
            type: Number,
            default () {
                return millisecond * sixty * sixty * timeOfDay; // 默认24小时
            }
        },
        areaUrl: {
            type: String,
            default () {
                return '';
            }
        }
    },
    data () {
        const _this = this;
        return {
            LEAF_INDEX: 4,
            AREA_TYPE: ['PLACE_PROVINCE', 'PLACE_CITY', 'PLACE_DISTRICT', 'PLACE_STREET'],
            addressArr: [],
            addressOptions: [],
            AREA_MAP: new Map(),
            extendProps: {
                lazy: true,
                lazyLoad (node, resolve) {
                    const { level, children } = node;
                    const params = {
                        ebplType: _this.AREA_TYPE[level]
                    };
                    if (level === 0) {
                        params.ebplParentPmCode = '100000';
                    } else {
                        params.ebplParentPmCode = node.value;
                    }
                    getAreaApi(params, _this.difference, _this.areaUrl).then(res => {
                        const nodes = res.data.map(item => {
                            // 将查询之后的区域对象放到一个map中，给地址code解析地址名称用
                            _this.AREA_MAP.set(item.ebplCode, item.ebplNameCn);
                            return _this.optionsFormat(item, level + 1 >= _this.leafIndex);
                        });
                        if (level !== 0 && children) {
                            node.children = [];
                        }
                        resolve(nodes);
                        // 除了有默认的时候不会调用lazyLoad，其他数据变化都会执行，所以在这里进行单选框的隐藏判断
                        if (level < _this.minLayers - 1) {
                            _this.disabledRadio(level);
                        }
                    });
                }
            }
        };
    },
    methods: {
        toggleExpand() {
            // 通过 ref 获取组件实例，并尝试修改其内部状态（这通常需要深入了解组件的实现细节）
            // 注意：这种方法依赖于组件的内部实现，不保证在所有情况下都有效。
            if (this.$refs.cascader) {
                // 由于 el-cascader 没有公开的 API 来直接操作 expanded 状态，通常需要借助 Vue 的 nextTick 来确保 DOM 更新完成后再操作。
                this.$nextTick(() => {
                // 这里通常需要更深层次的操作或使用事件触发机制（如模拟点击事件）来间接影响 expanded 状态。
                // 比如，你可以尝试通过模拟点击的方式来触发展开/折叠（这不是最优雅的解决方案，但有时可行）。
                // let dropdown = this.$refs.cascader.$el.querySelector('.el-cascader-menu');
                let dropdown = this.$refs.cascader.$el;
                
                if (dropdown) {
                    dropdown.click(); // 模拟点击以尝试展开或折叠菜单。
                }
                });
            }
        },
        changeHandle (value) {
            this.$emit('change', value);
            this.$emit('getAddress', this.addressFormat(value));
        },
        optionsFormat (item, isLeaf) {
            return {
                label: item.ebplNameCn,
                value: item.ebplCode,
                leaf: isLeaf
            };
        },
        disabledRadio (level) {
            // 只有选择任意级的时候才需要对radio禁用
            if (this.basicProps.checkStrictly) {
                this.$nextTick(() => {
                    if (this.$refs.cascader.panel.$el.getElementsByClassName('el-cascader-menu__list')[level]) {
                        const menuListDom = this.$refs.cascader.panel.$el.getElementsByClassName('el-cascader-menu__list')[level];

                        // menuListDom.className = menuListDom.className.replace(' disable-radio', '') + ' disable-radio';
                    }
                });
            }
        },
        // 下拉框监听事件
        visibleChange (val) {
            if (val) {
                if (!this.value) {
                    // 每次打开下拉框的时候重新从一级选起
                    this.addressOptions = this.addressOptions || this.addressOptions.map(item => {
                        Reflect.deleteProperty(item, 'children');
                        return item;
                    });
                } else {
                    // 传入的地址数组长度和可选级数的限制（minLayers）进行比较，取长度较短者
                    const length = this.value.length > this.minLayers - 1 ? this.minLayers - 1 : this.value.length;
                    // 有默认值的时候进行单选框的显示或隐藏判断
                    for (let i = 0; i < length; i++) {
                        this.disabledRadio(i);
                    }
                }
            }
        },
        async init (value) {
            // 判断传进来的v-model的值是数组或者字符串
            if (_.isString(value)) {
                // 对传入的字符串进行是省市区哪个级别的处理
                this.addressArr = [3, 5, 7, 10].map(item => {
                    return value.length >= item ? value.substr(0, item) : '';
                }).filter(item => item);
            } else if (_.isArray(value)) {
                this.addressArr = value;
            }
            // 递归获取默认值options
            this.addressOptions = await this.getArea(100000, this.addressArr, 0);
        },
        // 获取地址列表
        async getArea (ebplParentPmCode, addressArr, level) {
            // 根据地址的层级获取数据
            if (!addressArr[level]) return [];
            const res = await getAreaApi({
                ebplParentPmCode,
                ebplType: this.AREA_TYPE[level]
            }, this.difference, this.areaUrl);
            if (res && res.code === '0') {
                const nodes = res.data.map(item => {
                    this.AREA_MAP.set(item.ebplCode, item.ebplNameCn);
                    return this.optionsFormat(item, level + 1 >= this.leafIndex);
                });
                // 获取当前选中的项被获取子地址列表
                const nextNode = nodes.find(item => item.value === addressArr[level]);
                if (nextNode) {
                    nextNode.children = await this.getArea(nextNode.value, addressArr, ++level);
                }
                return nodes;
            }
        },
        // 输入框变化监听事件
        change (codeList) {
            let nameList = this.addressFormat(codeList)
            // console.log('change1-codeList',codeList);
            // console.log('change-nameArr',nameList);
            let values = [];
            if(Array.isArray(codeList)) {
                for (let i = 0; i < codeList.length; i++) {
                    let row ={label:'',value:''}
                    const codeArr = codeList[i];
                    const nameArr = nameList[i];
                    row.label = nameArr.join(',').replaceAll(',', '');
                    row.separateLabel =nameArr.join(',').replaceAll(',', '-');
                    row.value = codeArr.join('-');
                    values.push(row);
                }
            }
            // console.log('change-values',values);
            this.$emit('input', values);
            this.$emit('getAddress', values);
            if (!this.basicProps.multiple && this.basicProps.checkStrictly) {
                this.$refs.cascader.toggleDropDownVisible(false);
            }
        },
        // 提供给外部的解析地址code的函数，入参：['code1', 'code2',...], 出参：['name1','name2',...]
        addressFormat (arr) {
            let result = [];
            // console.log('AREA_MAP', this.AREA_MAP);
            
            if (_.isArray(arr)) {
                result = arr.map(itemArr => {
                    let allList=[];
                    if(Array.isArray(itemArr)){
                        let arrList=[];
                        for (const item of itemArr) {
                            arrList.push(this.AREA_MAP.get(item))
                        }
                        allList.push(arrList)
                    }
                    
                    return allList;
                });
            }
            
            return result;
        }
    },
    computed: {
        propsConfig () {
            return { ...this.basicProps, ...this.extendProps };
        },
        leafIndex () {
            return this.minLayers || this.LEAF_INDEX;
        }
    },
    watch: {
        value: {
            handler (val) {
                if (val) {
                    // this.init(val);
                } else {
                    this.addressArr = [];
                }
            },
            immediate: true
        }
    }
};
</script>
<style lang="less">
.m-address-select-inner {
    width: 100%;

    .i-cascader-component {
        width: 100%;

        .el-cascader {
            width: 100%;
        }
    }
    .el-cascader__tags{
        display: none;
    }
    .el-input{
         display: none;
    }
}

.no-select-province .el-cascader-panel > :first-child {
    .el-checkbox {
        display: none;
    }
}
</style>